import { ContentId } from 'src/utils/constants/contentId';

import {
  EventSortByFields,
  EventSortDisplayConfig,
  IneventorySortingType,
  InventoryEventSortingCriteria,
  InventoryListingSortingCriteria,
  ListingSortByFields,
  ListingSortDisplayConfig,
} from './MobileInventorySortAndFilterContext.types';

export const ListingSortByFieldsToContentId: Record<
  ListingSortByFields,
  ContentId
> = {
  [ListingSortByFields.Price]: ContentId.Price,
  [ListingSortByFields.UnitCost]: ContentId.UnitCost,
  [ListingSortByFields.Quantity]: ContentId.Quantity,
  [ListingSortByFields.Seating]: ContentId.Seating,
};

export const EventSortByFieldsToContentId: Record<
  EventSortByFields,
  ContentId
> = {
  [EventSortByFields.EventDate]: ContentId.EventDate,
  [EventSortByFields.EventName]: ContentId.EventName,
  [EventSortByFields.VenueName]: ContentId.VenueName,
  [EventSortByFields.UnsoldListings]: ContentId.UnsoldQuantity,
  [EventSortByFields.TicketCount]: ContentId.TotalTicketQuantity,
};

export const ListingSortDisplayConfigToContentId: Record<
  ListingSortDisplayConfig,
  ContentId
> = {
  [ListingSortDisplayConfig.HideAllDefects]: ContentId.HideAllDefects,
  [ListingSortDisplayConfig.HideAllFanInventory]: ContentId.HideAllFanInventory,
  [ListingSortDisplayConfig.HideSoldInventory]: ContentId.HideSoldInventory,
};

export const EventSortDisplayConfigToContentId: Record<
  EventSortDisplayConfig,
  ContentId
> = {
  [EventSortDisplayConfig.HideSoldThrough]: ContentId.HideSoldThroughEvents,
  [EventSortDisplayConfig.HidePortfolioInsights]:
    ContentId.HidePortfolioInsights,
  [EventSortDisplayConfig.CollapseAllGroups]: ContentId.CollapseAllGroups,
};

export const defaultListingSortingCriteria: InventoryListingSortingCriteria = {
  type: IneventorySortingType.Listing,
  sorting: {
    sortBy: ListingSortByFields.Price,
    order: 'asc',
  },
  displayConfig: {
    configs: [ListingSortDisplayConfig.HideSoldInventory],
  },
};

export const defaultEventSortingCriteria: InventoryEventSortingCriteria = {
  type: IneventorySortingType.Event,
  sorting: {
    sortBy: EventSortByFields.EventDate,
    order: 'asc',
  },
  displayConfig: {
    configs: [EventSortDisplayConfig.HideSoldThrough],
  },
};
